import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _29f09dda = () => interopDefault(import('../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _2ed17160 = () => interopDefault(import('../pages/affiliate-programme.vue' /* webpackChunkName: "pages/affiliate-programme" */))
const _1b6f942c = () => interopDefault(import('../pages/bike-insurance.vue' /* webpackChunkName: "pages/bike-insurance" */))
const _3ab0f79c = () => interopDefault(import('../pages/bike-theft-insurance.vue' /* webpackChunkName: "pages/bike-theft-insurance" */))
const _57ab2ebe = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _a55c7e04 = () => interopDefault(import('../pages/calculator.vue' /* webpackChunkName: "pages/calculator" */))
const _24b2309b = () => interopDefault(import('../pages/cargo-bike-insurance.vue' /* webpackChunkName: "pages/cargo-bike-insurance" */))
const _66e6cadb = () => interopDefault(import('../pages/chatgpt-app.vue' /* webpackChunkName: "pages/chatgpt-app" */))
const _0bd28c20 = () => interopDefault(import('../pages/claim.vue' /* webpackChunkName: "pages/claim" */))
const _14ee070c = () => interopDefault(import('../pages/commuter-cycle-insurance.vue' /* webpackChunkName: "pages/commuter-cycle-insurance" */))
const _860734ea = () => interopDefault(import('../pages/contact-permissions.vue' /* webpackChunkName: "pages/contact-permissions" */))
const _731198e7 = () => interopDefault(import('../pages/contact-us.vue' /* webpackChunkName: "pages/contact-us" */))
const _7d3a5a6a = () => interopDefault(import('../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _ff03f75c = () => interopDefault(import('../pages/electric-bike-insurance.vue' /* webpackChunkName: "pages/electric-bike-insurance" */))
const _7cb4fdcd = () => interopDefault(import('../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _0ceb55d5 = () => interopDefault(import('../pages/hiplok.vue' /* webpackChunkName: "pages/hiplok" */))
const _b4d4bac6 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _6cbb48e2 = () => interopDefault(import('../pages/mountain-bike-insurance.vue' /* webpackChunkName: "pages/mountain-bike-insurance" */))
const _501c038d = () => interopDefault(import('../pages/policy-information.vue' /* webpackChunkName: "pages/policy-information" */))
const _6e289ec3 = () => interopDefault(import('../pages/price-match-promise.vue' /* webpackChunkName: "pages/price-match-promise" */))
const _317ed2b3 = () => interopDefault(import('../pages/quote/index.vue' /* webpackChunkName: "pages/quote/index" */))
const _d6782922 = () => interopDefault(import('../pages/road-bike-insurance.vue' /* webpackChunkName: "pages/road-bike-insurance" */))
const _076b6d1c = () => interopDefault(import('../pages/road-cycling.vue' /* webpackChunkName: "pages/road-cycling" */))
const _70d81dca = () => interopDefault(import('../pages/triathlon-cycle-insurance.vue' /* webpackChunkName: "pages/triathlon-cycle-insurance" */))
const _b0a1ad1e = () => interopDefault(import('../pages/welcome-back/index.vue' /* webpackChunkName: "pages/welcome-back/index" */))
const _63f9b415 = () => interopDefault(import('../pages/what-we-cover.vue' /* webpackChunkName: "pages/what-we-cover" */))
const _c88bb3f4 = () => interopDefault(import('../pages/auth/email-link.vue' /* webpackChunkName: "pages/auth/email-link" */))
const _0a5da296 = () => interopDefault(import('../pages/auth/handoff.vue' /* webpackChunkName: "pages/auth/handoff" */))
const _ef8c9b30 = () => interopDefault(import('../pages/dashboard/assetverify-resume.vue' /* webpackChunkName: "pages/dashboard/assetverify-resume" */))
const _cb7de58c = () => interopDefault(import('../pages/dashboard/settings.vue' /* webpackChunkName: "pages/dashboard/settings" */))
const _c6b730ce = () => interopDefault(import('../pages/success/gocardless.vue' /* webpackChunkName: "pages/success/gocardless" */))
const _46765f42 = () => interopDefault(import('../pages/success/mta.vue' /* webpackChunkName: "pages/success/mta" */))
const _5ef9ccb5 = () => interopDefault(import('../pages/success/renew.vue' /* webpackChunkName: "pages/success/renew" */))
const _570e542d = () => interopDefault(import('../pages/policy/renew/cancel.vue' /* webpackChunkName: "pages/policy/renew/cancel" */))
const _482400f4 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _1844ebaf = () => interopDefault(import('../pages/blog/page/_page.vue' /* webpackChunkName: "pages/blog/page/_page" */))
const _eee549b2 = () => interopDefault(import('../pages/blog/tag/_slug/index.vue' /* webpackChunkName: "pages/blog/tag/_slug/index" */))
const _e44a694a = () => interopDefault(import('../pages/dashboard/policy-edit/_policyid.vue' /* webpackChunkName: "pages/dashboard/policy-edit/_policyid" */))
const _f508e046 = () => interopDefault(import('../pages/dashboard/policy-mta-complete/_policyid.vue' /* webpackChunkName: "pages/dashboard/policy-mta-complete/_policyid" */))
const _de72a5ae = () => interopDefault(import('../pages/dashboard/policy-review/_policyid.vue' /* webpackChunkName: "pages/dashboard/policy-review/_policyid" */))
const _50f1b0a9 = () => interopDefault(import('../pages/dashboard/policy/_policyid/index.vue' /* webpackChunkName: "pages/dashboard/policy/_policyid/index" */))
const _89359cce = () => interopDefault(import('../pages/dashboard/policy/_policyid/claim-damage.vue' /* webpackChunkName: "pages/dashboard/policy/_policyid/claim-damage" */))
const _2a7bd49c = () => interopDefault(import('../pages/dashboard/policy/_policyid/claim-intro.vue' /* webpackChunkName: "pages/dashboard/policy/_policyid/claim-intro" */))
const _882b299c = () => interopDefault(import('../pages/dashboard/policy/_policyid/claim-intro-typebot.vue' /* webpackChunkName: "pages/dashboard/policy/_policyid/claim-intro-typebot" */))
const _a68aba76 = () => interopDefault(import('../pages/dashboard/policy/_policyid/claim-theft.vue' /* webpackChunkName: "pages/dashboard/policy/_policyid/claim-theft" */))
const _5102ae59 = () => interopDefault(import('../pages/dashboard/policy/_policyid/details.vue' /* webpackChunkName: "pages/dashboard/policy/_policyid/details" */))
const _49e6ed57 = () => interopDefault(import('../pages/dashboard/policy/_policyid/refer.vue' /* webpackChunkName: "pages/dashboard/policy/_policyid/refer" */))
const _aadac62e = () => interopDefault(import('../pages/blog/tag/_slug/page/_page.vue' /* webpackChunkName: "pages/blog/tag/_slug/page/_page" */))
const _6c8e1184 = () => interopDefault(import('../pages/dashboard/policy/_policyid/claim/_id.vue' /* webpackChunkName: "pages/dashboard/policy/_policyid/claim/_id" */))
const _5b18714e = () => interopDefault(import('../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _49120f75 = () => interopDefault(import('../pages/faq/_id.vue' /* webpackChunkName: "pages/faq/_id" */))
const _4be9042c = () => interopDefault(import('../pages/instalment-plan/_policyCode.vue' /* webpackChunkName: "pages/instalment-plan/_policyCode" */))
const _35fdde9e = () => interopDefault(import('../pages/quote-complete/_quoteId.vue' /* webpackChunkName: "pages/quote-complete/_quoteId" */))
const _2c25b0b2 = () => interopDefault(import('../pages/quote-setup/_policyCode/index.vue' /* webpackChunkName: "pages/quote-setup/_policyCode/index" */))
const _1fe3c00a = () => interopDefault(import('../pages/welcome-back/_quoteCode.vue' /* webpackChunkName: "pages/welcome-back/_quoteCode" */))
const _2f36d022 = () => interopDefault(import('../pages/quote-setup/_policyCode/details.vue' /* webpackChunkName: "pages/quote-setup/_policyCode/details" */))
const _4c8c8de6 = () => interopDefault(import('../pages/quote-setup/_policyCode/payment.vue' /* webpackChunkName: "pages/quote-setup/_policyCode/payment" */))
const _cf6dbcb0 = () => interopDefault(import('../pages/quote/_quoteid/accessories.vue' /* webpackChunkName: "pages/quote/_quoteid/accessories" */))
const _686e5476 = () => interopDefault(import('../pages/quote/_quoteid/add-bike.vue' /* webpackChunkName: "pages/quote/_quoteid/add-bike" */))
const _2a4465d2 = () => interopDefault(import('../pages/quote/_quoteid/annual.vue' /* webpackChunkName: "pages/quote/_quoteid/annual" */))
const _20b2874c = () => interopDefault(import('../pages/quote/_quoteid/competitions.vue' /* webpackChunkName: "pages/quote/_quoteid/competitions" */))
const _62dff92a = () => interopDefault(import('../pages/quote/_quoteid/foreign-travel.vue' /* webpackChunkName: "pages/quote/_quoteid/foreign-travel" */))
const _69806cb4 = () => interopDefault(import('../pages/quote/_quoteid/make.vue' /* webpackChunkName: "pages/quote/_quoteid/make" */))
const _6e484805 = () => interopDefault(import('../pages/quote/_quoteid/monthly.vue' /* webpackChunkName: "pages/quote/_quoteid/monthly" */))
const _7072ea58 = () => interopDefault(import('../pages/quote/_quoteid/offer.vue' /* webpackChunkName: "pages/quote/_quoteid/offer" */))
const _e222c8bc = () => interopDefault(import('../pages/quote/_quoteid/personal-cover.vue' /* webpackChunkName: "pages/quote/_quoteid/personal-cover" */))
const _0ae614e1 = () => interopDefault(import('../pages/quote/_quoteid/public-liability.vue' /* webpackChunkName: "pages/quote/_quoteid/public-liability" */))
const _0a04c871 = () => interopDefault(import('../pages/quote/_quoteid/start-date.vue' /* webpackChunkName: "pages/quote/_quoteid/start-date" */))
const _5c3c29c4 = () => interopDefault(import('../pages/quote/_quoteid/summary.vue' /* webpackChunkName: "pages/quote/_quoteid/summary" */))
const _7259e622 = () => interopDefault(import('../pages/policy/_policyid/renew/annually.vue' /* webpackChunkName: "pages/policy/_policyid/renew/annually" */))
const _67b34af2 = () => interopDefault(import('../pages/policy/_policyid/renew/monthly.vue' /* webpackChunkName: "pages/policy/_policyid/renew/monthly" */))
const _412bc959 = () => interopDefault(import('../pages/policy/_policyid/renew/premfina/index.vue' /* webpackChunkName: "pages/policy/_policyid/renew/premfina/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _29f09dda,
    name: "about-us"
  }, {
    path: "/affiliate-programme",
    component: _2ed17160,
    name: "affiliate-programme"
  }, {
    path: "/bike-insurance",
    component: _1b6f942c,
    name: "bike-insurance"
  }, {
    path: "/bike-theft-insurance",
    component: _3ab0f79c,
    name: "bike-theft-insurance"
  }, {
    path: "/blog",
    component: _57ab2ebe,
    name: "blog"
  }, {
    path: "/calculator",
    component: _a55c7e04,
    name: "calculator"
  }, {
    path: "/cargo-bike-insurance",
    component: _24b2309b,
    name: "cargo-bike-insurance"
  }, {
    path: "/chatgpt-app",
    component: _66e6cadb,
    name: "chatgpt-app"
  }, {
    path: "/claim",
    component: _0bd28c20,
    name: "claim"
  }, {
    path: "/commuter-cycle-insurance",
    component: _14ee070c,
    name: "commuter-cycle-insurance"
  }, {
    path: "/contact-permissions",
    component: _860734ea,
    name: "contact-permissions"
  }, {
    path: "/contact-us",
    component: _731198e7,
    name: "contact-us"
  }, {
    path: "/dashboard",
    component: _7d3a5a6a,
    name: "dashboard"
  }, {
    path: "/electric-bike-insurance",
    component: _ff03f75c,
    name: "electric-bike-insurance"
  }, {
    path: "/faq",
    component: _7cb4fdcd,
    name: "faq"
  }, {
    path: "/hiplok",
    component: _0ceb55d5,
    name: "hiplok"
  }, {
    path: "/login",
    component: _b4d4bac6,
    name: "login"
  }, {
    path: "/mountain-bike-insurance",
    component: _6cbb48e2,
    name: "mountain-bike-insurance"
  }, {
    path: "/policy-information",
    component: _501c038d,
    name: "policy-information"
  }, {
    path: "/price-match-promise",
    component: _6e289ec3,
    name: "price-match-promise"
  }, {
    path: "/quote",
    component: _317ed2b3,
    name: "quote"
  }, {
    path: "/road-bike-insurance",
    component: _d6782922,
    name: "road-bike-insurance"
  }, {
    path: "/road-cycling",
    component: _076b6d1c,
    name: "road-cycling"
  }, {
    path: "/triathlon-cycle-insurance",
    component: _70d81dca,
    name: "triathlon-cycle-insurance"
  }, {
    path: "/welcome-back",
    component: _b0a1ad1e,
    name: "welcome-back"
  }, {
    path: "/what-we-cover",
    component: _63f9b415,
    name: "what-we-cover"
  }, {
    path: "/auth/email-link",
    component: _c88bb3f4,
    name: "auth-email-link"
  }, {
    path: "/auth/handoff",
    component: _0a5da296,
    name: "auth-handoff"
  }, {
    path: "/dashboard/assetverify-resume",
    component: _ef8c9b30,
    name: "dashboard-assetverify-resume"
  }, {
    path: "/dashboard/settings",
    component: _cb7de58c,
    name: "dashboard-settings"
  }, {
    path: "/success/gocardless",
    component: _c6b730ce,
    name: "success-gocardless"
  }, {
    path: "/success/mta",
    component: _46765f42,
    name: "success-mta"
  }, {
    path: "/success/renew",
    component: _5ef9ccb5,
    name: "success-renew"
  }, {
    path: "/policy/renew/cancel",
    component: _570e542d,
    name: "policy-renew-cancel"
  }, {
    path: "/",
    component: _482400f4,
    name: "index"
  }, {
    path: "/blog/page/:page?",
    component: _1844ebaf,
    name: "blog-page-page"
  }, {
    path: "/blog/tag/:slug",
    component: _eee549b2,
    name: "blog-tag-slug"
  }, {
    path: "/dashboard/policy-edit/:policyid?",
    component: _e44a694a,
    name: "dashboard-policy-edit-policyid"
  }, {
    path: "/dashboard/policy-mta-complete/:policyid?",
    component: _f508e046,
    name: "dashboard-policy-mta-complete-policyid"
  }, {
    path: "/dashboard/policy-review/:policyid?",
    component: _de72a5ae,
    name: "dashboard-policy-review-policyid"
  }, {
    path: "/dashboard/policy/:policyid",
    component: _50f1b0a9,
    name: "dashboard-policy-policyid"
  }, {
    path: "/dashboard/policy/:policyid?/claim-damage",
    component: _89359cce,
    name: "dashboard-policy-policyid-claim-damage"
  }, {
    path: "/dashboard/policy/:policyid?/claim-intro",
    component: _2a7bd49c,
    name: "dashboard-policy-policyid-claim-intro"
  }, {
    path: "/dashboard/policy/:policyid?/claim-intro-typebot",
    component: _882b299c,
    name: "dashboard-policy-policyid-claim-intro-typebot"
  }, {
    path: "/dashboard/policy/:policyid?/claim-theft",
    component: _a68aba76,
    name: "dashboard-policy-policyid-claim-theft"
  }, {
    path: "/dashboard/policy/:policyid?/details",
    component: _5102ae59,
    name: "dashboard-policy-policyid-details"
  }, {
    path: "/dashboard/policy/:policyid?/refer",
    component: _49e6ed57,
    name: "dashboard-policy-policyid-refer"
  }, {
    path: "/blog/tag/:slug?/page/:page?",
    component: _aadac62e,
    name: "blog-tag-slug-page-page"
  }, {
    path: "/dashboard/policy/:policyid?/claim/:id?",
    component: _6c8e1184,
    name: "dashboard-policy-policyid-claim-id"
  }, {
    path: "/blog/:slug",
    component: _5b18714e,
    name: "blog-slug"
  }, {
    path: "/faq/:id",
    component: _49120f75,
    name: "faq-id"
  }, {
    path: "/instalment-plan/:policyCode?",
    component: _4be9042c,
    name: "instalment-plan-policyCode"
  }, {
    path: "/quote-complete/:quoteId",
    component: _35fdde9e,
    name: "quote-complete-quoteId"
  }, {
    path: "/quote-setup/:policyCode",
    component: _2c25b0b2,
    name: "quote-setup-policyCode"
  }, {
    path: "/welcome-back/:quoteCode?",
    component: _1fe3c00a,
    name: "welcome-back-quoteCode"
  }, {
    path: "/quote-setup/:policyCode/details",
    component: _2f36d022,
    name: "quote-setup-policyCode-details"
  }, {
    path: "/quote-setup/:policyCode/payment",
    component: _4c8c8de6,
    name: "quote-setup-policyCode-payment"
  }, {
    path: "/quote/:quoteid/accessories",
    component: _cf6dbcb0,
    name: "quote-quoteid-accessories"
  }, {
    path: "/quote/:quoteid/add-bike",
    component: _686e5476,
    name: "quote-quoteid-add-bike"
  }, {
    path: "/quote/:quoteid/annual",
    component: _2a4465d2,
    name: "quote-quoteid-annual"
  }, {
    path: "/quote/:quoteid/competitions",
    component: _20b2874c,
    name: "quote-quoteid-competitions"
  }, {
    path: "/quote/:quoteid/foreign-travel",
    component: _62dff92a,
    name: "quote-quoteid-foreign-travel"
  }, {
    path: "/quote/:quoteid/make",
    component: _69806cb4,
    name: "quote-quoteid-make"
  }, {
    path: "/quote/:quoteid/monthly",
    component: _6e484805,
    name: "quote-quoteid-monthly"
  }, {
    path: "/quote/:quoteid/offer",
    component: _7072ea58,
    name: "quote-quoteid-offer"
  }, {
    path: "/quote/:quoteid/personal-cover",
    component: _e222c8bc,
    name: "quote-quoteid-personal-cover"
  }, {
    path: "/quote/:quoteid/public-liability",
    component: _0ae614e1,
    name: "quote-quoteid-public-liability"
  }, {
    path: "/quote/:quoteid/start-date",
    component: _0a04c871,
    name: "quote-quoteid-start-date"
  }, {
    path: "/quote/:quoteid/summary",
    component: _5c3c29c4,
    name: "quote-quoteid-summary"
  }, {
    path: "/policy/:policyid?/renew/annually",
    component: _7259e622,
    name: "policy-policyid-renew-annually"
  }, {
    path: "/policy/:policyid?/renew/monthly",
    component: _67b34af2,
    name: "policy-policyid-renew-monthly"
  }, {
    path: "/policy/:policyid?/renew/premfina",
    component: _412bc959,
    name: "policy-policyid-renew-premfina"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
